import React, { FC } from 'react';
import { BasicContainer, Loader } from '@minecraft.atoms';
import { PaymentLoader } from '../Checkout/PaymentLoader';
import { SuccessOrderSummary } from './SuccessOrderSummary';
import { SuccessHero } from './SuccessHero';
import { OrderSuccessWrapperProps } from './types';

export const OrderSuccessWraper: FC<OrderSuccessWrapperProps> = React.memo(
  ({
    isModal,
    selectedPlan,
    lessMd,
    currencyCode,
    countryCode,
    completedPurchase,
    completePurchaseLoading,
    paywallLocation,
    subscription,
    onPaymentCompleteRedirect = () => null,
    closeBillingPopup,
  }) => {
    const isLoading = !completedPurchase || completePurchaseLoading;

    return (
      <BasicContainer className="cn_w-full" data-testid="order-success-container" mb="8">
        <Loader loading={isLoading} LoaderComponent={<PaymentLoader />}>
          <SuccessHero
            isModal={isModal}
            selectedPlan={selectedPlan}
            lessMd={lessMd}
            completedPurchase={completedPurchase}
            subscription={subscription}
            currencyCode={currencyCode}
          />
          <SuccessOrderSummary
            selectedPlan={selectedPlan}
            currencyCode={currencyCode}
            completedPurchase={completedPurchase}
            paywallLocation={paywallLocation}
            onPaymentCompleteRedirect={onPaymentCompleteRedirect}
            countryCode={countryCode}
            closeBillingPopup={closeBillingPopup}
          />
        </Loader>
      </BasicContainer>
    );
  }
);
